(() => {
  const normalize = (value) => String(value || '').trim().toLowerCase().replace(/^gray$/, 'grey');
  const mediaId = (element) => (element.dataset.mediaId || element.dataset.target || '').split('-').pop();

  function refreshSlider(component) {
    if (!component?.slider) return;
    component.slider.scrollTo({ left: 0, behavior: 'instant' });
    component.resetPages?.();
    // The theme's slider returns early for a single item. Give it valid counters
    // so subsequent scroll/resize events cannot dispatch an undefined slide.
    if (component.sliderItemsToShow?.length === 1) {
      component.sliderItemOffset = component.sliderItemsToShow[0].clientWidth || 1;
      component.slidesPerPage = 1;
      component.totalPages = 1;
      component.currentPage = 1;
      component.update?.();
    }
  }

  function initialize(dataElement) {
    const gallery = dataElement.closest('media-gallery');
    if (!gallery || gallery.dataset.nsColorFilter) return;
    let data;
    try { data = JSON.parse(dataElement.textContent); } catch { return; }
    const picker = document.querySelector(`variant-radios[data-section="${data.section}"], variant-selects[data-section="${data.section}"]`);
    const slides = [...gallery.querySelectorAll('[id^="Slider-Gallery-"] > [data-media-id]')];
    const thumbnails = [...gallery.querySelectorAll('[id^="Slider-Thumbnails-"] > [data-target]')];
    if (!picker || !slides.length || typeof gallery.setActiveMedia !== 'function') return;

    const colors = new Map();
    const addColor = (id, color) => {
      if (id == null || !normalize(color)) return;
      const key = String(id);
      if (!colors.has(key)) colors.set(key, new Set());
      colors.get(key).add(normalize(color));
    };
    data.variants.forEach((variant) => addColor(variant.media, variant.color));
    data.media.forEach((media) => {
      const explicitColor = (media.alt || '').match(/^\[color:\s*([^\]]+)\]/i)?.[1];
      if (explicitColor) addColor(media.id, explicitColor);
      else if (!colors.has(String(media.id))) addColor(media.id, data.overrides[String(media.id)]);
    });

    let lastColor;
    const apply = () => {
      const fieldset = picker.querySelectorAll('fieldset')[data.colorIndex];
      const select = picker.querySelectorAll('select')[data.colorIndex];
      const selected = fieldset?.querySelector('input:checked')?.value || select?.value || data.selectedColor;
      const color = normalize(selected);
      const allowed = slides.filter((slide) => {
        const group = colors.get(mediaId(slide));
        return !group?.size || group.has(color);
      });
      // Unknown or newly introduced color data must never leave a blank gallery.
      if (!allowed.length) return;
      const allowedIds = new Set(allowed.map(mediaId));
      gallery.dataset.nsColor = selected;
      gallery.toggleAttribute('data-ns-color-single', allowed.length === 1);
      [...slides, ...thumbnails].forEach((element) => {
        const hidden = !allowedIds.has(mediaId(element));
        element.hidden = hidden;
        element.toggleAttribute('data-ns-color-hidden', hidden);
      });
      const active = slides.find((slide) => slide.classList.contains('is-active'));
      if (lastColor !== color || !active || active.hidden) {
        const featured = data.variants.find((variant) => normalize(variant.color) === color)?.media;
        const next = allowed.find((slide) => mediaId(slide) === String(featured)) || allowed[0];
        gallery.setActiveMedia(next.dataset.mediaId, false);
      }
      refreshSlider(gallery.elements?.viewer);
      refreshSlider(gallery.elements?.thumbnails);
      lastColor = color;
    };
    gallery.dataset.nsColorFilter = 'true';
    picker.addEventListener('change', () => queueMicrotask(apply));
    apply();
  }

  const start = (root = document) => customElements.whenDefined('media-gallery').then(() => {
    root.querySelectorAll('[data-ns-color-gallery-data]').forEach(initialize);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(), { once: true });
  else start();
  document.addEventListener('shopify:section:load', (event) => start(event.target));
})();
